import Link from "next/link";

import type { ChannelFeedRelatedArtifacts } from "@mlx/contracts";
import { artifactWorkspaceHref } from "@/lib/artifact-session-route";
import { channelFeedRunArtifact } from "./channel-feed-artifact";

export function ChannelSessionArtifactLinks({
  related,
}: {
  related: ChannelFeedRelatedArtifacts;
}) {
  if (related.totalCount === 0) return null;
  return (
    <div className="flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1 text-2xs text-muted-foreground">
      <span>Artifacts</span>
      {related.items.map((item) => {
        const artifact = channelFeedRunArtifact(item);
        if (!artifact) return null;
        const className =
          "max-w-48 truncate text-left underline-offset-4 hover:text-foreground hover:underline focus-visible:rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background";
        if (!artifact.contentKind && !artifact.href) return null;
        return artifact.contentKind ? (
          <Link
            key={item.id}
            href={artifactWorkspaceHref(artifact.id, artifact.sessionId)}
            className={className}
          >
            {item.title}
          </Link>
        ) : (
          <Link
            key={item.id}
            href={artifact.href!}
            target="_blank"
            rel="noreferrer"
            className={className}
          >
            {item.title}
          </Link>
        );
      })}
      {related.totalCount > related.items.length ? (
        <span>+{related.totalCount - related.items.length}</span>
      ) : null}
    </div>
  );
}
